module.exports = __webpack_public_path__ + "img/bg_Dots.61cd6cdd.png";